const pm = {
  common: {
    proFeature: "{name} ميزة من ميزات Pro.", micUnavailable: "الميكروفون غير متاح.",
    noAudio: "لم يُلتقط أي صوت — حاول مرة أخرى.", voiceUnavailable: "الصوت غير متاح الآن.",
    messageFailed: "تعذّر إرسال الرسالة. حاول مرة أخرى.",
  },
  scores: { accuracy: "الدقة", fluency: "الطلاقة", completeness: "الاكتمال", grammar: "القواعد", persuasiveness: "قوة الإقناع" },
  roommate: {
    subtitle: "تحدّث مع شريك بالذكاء الاصطناعي. سيصحّح أخطاءك بلطف ويعلّمك كلمات جديدة.",
    hint: "نصيحة: أجب بجمل كاملة — يصحّح لك Roommate بلطف ويحفظ الكلمات الجديدة من أجلك.",
    sayHello: "ألقِ التحية لتبدأ!", typeIn: "اكتب باللغة {lang}…", typeTarget: "اكتب باللغة التي تتعلّمها…",
    wordsToday: "كلمات اليوم", newWordsHere: "تظهر الكلمات الجديدة هنا.",
    corrections: "تصحيحات لطيفة", doingGreat: "أداؤك رائع!",
    personas: {
      roommate: { label: "زميل السكن", scenario: "دردشة في المنزل داخل المطبخ" },
      cafe: { label: "مقهى", scenario: "طلب قهوة في مقهى مزدحم" },
      market: { label: "سوق", scenario: "شراء الفاكهة من سوق شعبي" },
      clinic: { label: "عيادة", scenario: "فحص طبي في العيادة" },
    },
  },
  accent: {
    subtitle: "قل العبارة بصوت عالٍ. سنقيّم نطقك ثم نتدرّب على أضعف جزء. لا نحتفظ بتسجيلك أبدًا.",
    hint: "نصيحة: استخدم سماعات الرأس وسجّل في مكان هادئ للحصول على أدق تقييم. اضغط على مكبّر الصوت الخاص بالعبارة لتسمعها أولًا.",
    unavailable: "AccentCoach غير متاح لهذه اللغة بعد.",
    sayThis: "قل هذا · {level}", hear: "استمع", playing: "جارٍ التشغيل…", newPhrases: "عبارات جديدة",
    scoring: "جارٍ التقييم…", recording: "جارٍ التسجيل… اضغط للإيقاف", tapRecord: "اضغط للتسجيل",
    weHeard: "سمعنا:", focusOn: "ركّز على:", tryAgain: "حاول مرة أخرى", scoreFailed: "تعذّر التقييم. حاول مرة أخرى.",
  },
  debate: {
    showMeaning: "إظهار المعنى", hideMeaning: "إخفاء المعنى", topicFailed: "تعذّر إنشاء موضوع مناظرة باللغة {lang}. حاول مرة أخرى.",
    subtitle: "دافع عن الموقف المخصّص لك. يردّ عليك الذكاء الاصطناعي ويقيّم قواعدك وطلاقتك وقوة إقناعك. الأنسب لمستوى B2 فما فوق.",
    hintPre: "نصيحة: يمكنك أيضًا المناقشة", hintVoice: "بالصوت", hintPost: "— اضغط على الميكروفون لتقول حجّتك فتُفرَّغ نصيًا وتُقيَّم.",
    startTitle: "ابدأ مناظرة", topicPlaceholder: "اختياري: أدخل موضوعًا، أو اتركه فارغًا لمفاجأة",
    settingUp: "جارٍ التحضير…", begin: "ابدأ المناظرة", topic: "الموضوع", mustArgue: "عليك أن تدافع عن موقف:",
    sides: { for: "مع", against: "ضد" }, you: "أنت", opponent: "الخصم", roundScores: "نتائج الجولة",
    improve: "للتحسين:", thinking: "الخصم يفكّر…", argPlaceholder: "قدّم حجّتك…",
    voiceTitle: "ناقش بالصوت", transcribing: "🎙️ جارٍ تفريغ حجّتك نصيًا…",
    startFailed: "تعذّر بدء المناظرة.", roundFailed: "فشلت الجولة.", noAudio: "لم يُلتقط أي صوت.",
  },
  quiz: {
    subtitle: "اختبارات بالتكرار المتباعد مبنيّة من بنك مفرداتك الخاص.",
    hint: "نصيحة: يعرض «المراجعة المستحقّة» الكلمات التي توشك على نسيانها — ابدأ بها لتثبّتها نهائيًا.",
    wordsDue: { zero: "كلمات مستحقّة — راجعها الآن", one: "كلمة مستحقّة — راجعها الآن", two: "كلمتان مستحقّتان — راجعهما الآن", few: "كلمات مستحقّة — راجعها الآن", many: "كلمةً مستحقّة — راجعها الآن", other: "كلمة مستحقّة — راجعها الآن" },
    topicTitle: "اختبر نفسك في موضوع", topicPlaceholder: "مثل: الطعام، السفر", generate: "إنشاء",
    building: "جارٍ إعداد اختبارك…", question: "السؤال {n} من {total}",
    types: { mcq: "اختيار من متعدد", fill: "املأ الفراغ" },
    answerPlaceholder: "اكتب إجابتك", check: "تحقّق", correct: "{correct} من {total} صحيحة",
    xpEarned: { zero: "لم تكسب نقاط خبرة", one: "كسبت نقطة خبرة واحدة", two: "كسبت نقطتي خبرة", few: "كسبت {count} نقاط خبرة", many: "كسبت {count} نقطة خبرة", other: "كسبت {count} نقطة خبرة" }, back: "العودة إلى QuizForge",
    noQuestions: "لم تُنشأ أي أسئلة.", buildFailed: "تعذّر إعداد الاختبار.", gradeFailed: "تعذّر التصحيح.",
  },
  story: {
    title: "وضع القصص", subtitle: "قصة مكتوبة خصيصًا لك — أبطالها الكلمات التي التقطتها.",
    hint: "نصيحة: التقط مزيدًا من الكلمات في LanguageLoop، ثم اضغط على مكبّر الصوت في أي فصل لتسمعه بالصوت الذي اخترته.",
    beginTitle: "ابدأ قصة جديدة", beginSub: "اختر نوعًا — وسننسج مفرداتك فيها فصلًا بعد فصل.",
    themes: { mystery: "غموض", adventure: "مغامرة", romance: "رومانسية", scifi: "خيال علمي", slice: "الحياة اليومية" },
    ownIdea: "…أو اكتب فكرتك الخاصة", writing: "جارٍ الكتابة…", start: "ابدأ",
    chapters: { zero: "لا فصول", one: "فصل واحد", two: "فصلان", few: "{count} فصول", many: "{count} فصلًا", other: "{count} فصل" }, chapter: "الفصل {n}",
    listen: "استمع", translation: "الترجمة", writingNext: "جارٍ كتابة الفصل التالي…",
    continue: "تابع القصة", different: "ابدأ قصة مختلفة",
    unlocked: "فُتح الفصل {n}! وكسبت 10 نقاط خبرة", startFailed: "تعذّر بدء قصتك.", continueFailed: "تعذّرت متابعة القصة.",
  },
  mission: {
    steps: { warm_up: "الإحماء", core_task: "مهمتك", extension: "تحدٍّ إضافي" },
    keyWords: "كلمات وعبارات أساسية", challenge: "تحدّي المحادثة", fromBrief: "من وصف مهمتك.",
    newWordsHint: "تظهر هنا الكلمات الجديدة التي تصادفها — اضغط «إضافة» لحفظها.", noCorrections: "رائع — لا تصحيحات حتى الآن!",
    markFailed: "تعذّر وضع علامة الإكمال.", messageFailed: "تعذّر إرسال الرسالة.",
    added: { zero: "لم تُضف أي كلمة إلى بنك مفرداتك", one: "أُضيفت كلمة واحدة إلى بنك مفرداتك", two: "أُضيفت كلمتان إلى بنك مفرداتك", few: "أُضيفت {count} كلمات إلى بنك مفرداتك", many: "أُضيفت {count} كلمةً إلى بنك مفرداتك", other: "أُضيفت {count} كلمة إلى بنك مفرداتك" },
    addFailed: "تعذّرت الإضافة إلى بنك المفردات.", listen: "استمع",
  },
  library: {
    title: "مكتبة المهام", newMission: "مهمة جديدة",
    intro: "مهام الطلاقة الخاصة بك والقابلة لإعادة الاستخدام. إسناد مهمة لا يغيّر الأصل أبدًا — وإعادة استخدام مهمة محفوظة لا تستهلك أي توليد بالذكاء الاصطناعي.",
    search: "ابحث بالموضوع أو العنوان…", allLanguages: "كل اللغات", allLevels: "كل المستويات",
    sortRecent: "المعدّلة مؤخرًا", sortLastUsed: "آخر استخدام", empty: "مكتبتك فارغة",
    emptySub: "أنشئ مهمة هنا، أو احفظ مسودات من «إنشاء مهمة» في أي صف.",
    used: "مستخدمة", lastUsed: "آخر استخدام: {date}", assign: "إسناد", edit: "تعديل", duplicate: "نسخ", delete: "حذف",
    duplicated: "تم النسخ", dupFailed: "تعذّر النسخ",
    confirmDelete: "هل تريد حذف هذه المهمة من مكتبتك؟ لن تتأثر المهام المُسندة سابقًا.",
    deleted: "تم الحذف", delFailed: "تعذّر الحذف", assignTitle: "إسناد «{title}»",
    chooseClasses: "اختر الصفوف (التي تدرّسها)", noClasses: "ليست لديك صفوف نشطة.",
    dueOptional: "تاريخ الاستحقاق (اختياري)", assignMission: "إسناد المهمة", pickClass: "اختر صفًا واحدًا على الأقل.",
    assigned: { zero: "لم تُسند إلى أي صف.", one: "أُسندت إلى صف واحد.", two: "أُسندت إلى صفّين.", few: "أُسندت إلى {count} صفوف.", many: "أُسندت إلى {count} صفًا.", other: "أُسندت إلى {count} صف." }, assignFailed: "تعذّر الإسناد.",
    close: "إغلاق",
  },
  studio: {
    needPractice: "أخبرنا بما يجب أن يتدرّب عليه طلابك.", genFailed: "فشل التوليد. حاول مرة أخرى.",
    sectionRegen: "أُعيد توليد القسم", missionRegen: "أُعيد توليد المهمة", regenFailed: "فشلت إعادة التوليد.",
    assigned: "أُسندت المهمة إلى صفّك!", updated: "حُدّثت المهمة.", saved: "حُفظت في مكتبة مهامك.",
    saveFailed: "تعذّر الحفظ.", assignFailed: "تعذّر الإسناد.",
    editTitle: "تعديل المهمة", createTitle: "إنشاء مهمة طلاقة",
    classIntro: "أخبرنا بالهدف فقط — يعرف GetFluentLoop اللغة والمستوى مسبقًا.",
    language: "اللغة", level: "المستوى", practiceQ: "على ماذا يجب أن يتدرّب طلابك؟",
    practicePlaceholder: "مثل: طلب الطعام في مطعم وتقديم طلبات مهذّبة",
    designing: "جارٍ تصميم المهمة…", generateDraft: "توليد مسودة المهمة", regenAll: "إعادة توليد الكل",
    minutes: "~{count} دقيقة", regenerate: "إعادة التوليد",
    f: {
      title: "عنوان المهمة", intro: "مقدّمة للطلاب", objective: "هدف التعلّم", scenario: "السيناريو",
      warmup: "الإحماء", core: "المهمة الأساسية", challenge: "تحدّي المحادثة",
      mode: "وضع المحادثة (كيف يُكمل الطلاب التحدّي)",
      modeAny: "أي وضع — يختار الطالب التحدّث أو الكتابة", modeVoice: "يُشجَّع الصوت — حثّ على التحدّث (الكتابة متاحة دائمًا)",
      extension: "تحدٍّ إضافي (اختياري)", grammar: "القواعد / التركيز", minutes: "الدقائق المقدّرة", culture: "ملاحظة ثقافية",
      vocab: "المفردات المستهدفة (واحدة في كل سطر: الكلمة | الترجمة)", phrases: "عبارات مفيدة (واحدة في كل سطر: العبارة | الترجمة)",
      criteria: "معايير النجاح (واحد في كل سطر)", due: "تاريخ الاستحقاق (اختياري — تذكير لطيف، لا يمنع الطلاب أبدًا)",
    },
    saveChanges: "حفظ التغييرات", saveLibrary: "حفظ في المكتبة", assignClass: "إسناد إلى الصف",
  },
  paywall: {
    benefits: ["محادثات مباشرة مع Fluent Friend", "FluentLens", "المذكّرة الصوتية", "اليوم الذكي", "المفردات والتكرار المتباعد", "دماغ لغوي شخصي", "كل اللغات المدعومة"],
    tagline: "حياتك تصبح دورتك اللغوية.", month: "شهر",
    starting: "جارٍ البدء…", subscribe: "اشترك في Pro", later: "ربما لاحقًا", checkoutFailed: "تعذّر بدء الدفع. حاول مرة أخرى.",
  },
  consent: {
    titleCamera: "السماح بالوصول إلى الكاميرا؟", titleMic: "السماح بالوصول إلى الميكروفون؟",
    needsCamera: "يحتاج {brand} إلى كاميرتك للتعرّف على الأشياء.", needsMic: "يحتاج {brand} إلى الميكروفون لتقييم نطقك.",
    rawCamera: "تُعالَج صورتك الأصلية في الذاكرة ثم {del}. نحتفظ بالكلمة فقط.",
    rawMic: "يُعالَج تسجيلك الأصلي في الذاكرة ثم {del}. نحتفظ بالنتيجة فقط.",
    deletedCamera: "تُحذف فورًا", deletedMic: "يُحذف فورًا", grant: "أوافق — متابعة", notNow: "ليس الآن", close: "إغلاق",
  },
};
export default pm;
